<template>
  <div>
    <h2 v-if="editing">Editerar {{ node.name }}</h2>
    <h2 v-if="!editing">Spara din nya enhet</h2>
    
    <div class="descr" v-if="!editing">Det sista steget innan din enhet läggs till är att döpa den samt att välja ett rum. Om du ännu inte har lagt till något rum kan du hoppa över det steget och placera enheten i ett rum vid ett senare tillfälle.</div>
    <hr class="space">
    <!--{{ $root.tempSaveStore }}-->

    <div class="form">
      <div class="item">
        <div class="label">Namn</div>
        <div><input type="text" v-model="node.name" placeholder="Namn på enheten"></div>
      </div>

      <div class="item">
        <div class="label">Rum</div>
        <div>
          <select v-model="node.roomId">
            <option value="0" disabled>Välj ett rum (valfritt)</option>
            <option v-for="room in rooms" :value="room.id">{{ room.name }}</option>
          </select>
        </div>
      </div>
      
      <!--
      <div class="item">
        <div class="label">Typer</div>
        <select multiple v-model="node.capabilities" style="height:160px;">
          <option v-for="(value, key) in $root.capabilities">{{ key }}</option>
        </select>
        <div class="descr">Ovanstående beskriver vad en enhet kan göra och vad den har stöd för. Dessa väljs oftast automatiskt, du kan ändra ovanstående men gör det på egen risk.</div>
      </div>
      -->
      
      <div class="item" v-if="node.type === 'ZWave' && node.capabilities.includes('configuration')">
        <div class="label">Skicka konfigurationsparametrar</div>
        
        <table>
          <thead>
            <tr>
              <th>Parameternummer</th>
              <th>Storlek (size)</th>
              <th>Värde</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(param, i) in params" class="nohover">
              <td><input type="text" v-model.number="param.param"></td>
              <td>
                <select v-model.number="param.nrBytes">
                  <option value="1">1 byte</option>
                  <option value="2">2 bytes</option>
                  <option value="3">3 bytes</option>
                  <option value="4">4 bytes</option>
                </select>
              </td>
              <td><input type="text" v-model.number="param.intValue"></td>
              <td><button @click="delParam(i)">Radera</button></td>
            </tr>
            
            <tr class="nohover">
              <td colspan="4"><button @click="addParam">Lägg till värde</button></td>
            </tr>
            
          </tbody>
        </table>

        <div class="descr">Du kan skicka konfigurationsparametrar till din Z-Wave enhet för att göra vissa inställningar i den. Dessa inställningarna hittar du oftast i manualen eller tillhörande dokument. Om du inte vet vad du kan skicka så kan du kontakta supporten för din produkt för mer hjälp.</div>
      </div>

      <div class="item">
        <button v-if="!saving" @click="doSave" :disabled="!ok">{{ editing ? 'Spara ändringar' : 'Lägg till enhet' }}</button>
        <button v-else disabled>Sparar...</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import { eventbus } from '../eventbus.js';

export default {
  name: 'HelloWorld',
  data () {
    return {
      node: {},
      params: [],
      saving: false,
      editing: false
    }
  },

  created () {
    if ('id' in this.$route.params) {
      this.editing = true
      this.node = this.$root.data.nodes.find(node => node.id === this.$route.params.id)
    } else {
      this.node = {
        name: '',
        roomId: 0,
        capabilities: this.$root.tempSaveStore.capabilities,
        type: ''
      }
    }
  },
  
  computed: {
    rooms () {
      return this.$root.data.rooms.filter(room => room.id > 0)
    },
    
    ok () {
      return 'name' in this.node && this.node.name.length > 0
    }
  },
  
  methods: {
    addParam () {
      this.params.push({
        param: 0,
        nrBytes: 1,
        intValue: 0
      })
    },
    
    delParam (i) {
      this.params.splice(1, i)
    },
    
    doSave () {
      this.saving = true 

      let obj = {
        name: this.node.name,
        roomId: this.node.roomId,
      }
            
      if (this.node.type !== 'System2') {
        obj.capabilities = this.node.capabilities
      }
      
      console.log(obj)
      
      if (Object.keys(this.$root.tempSaveStore)) {
        for (var key in this.$root.tempSaveStore) {
          obj[key] = this.$root.tempSaveStore[key]
        }
      }

      let path = 'nodes'
      if (this.editing) {
        path += '/' + this.$route.params.id
      }

      // Spara enheten
      HTTP.post(path, obj)
      .then(res => res.data)
      .then(json => {
        // Kolla om vi skall skicka några konfigurationsparametrar
        // till enheten, isåfall gör vi det annars skickar vi 
        // vidare användaren.
        if (this.params.length) {
          HTTP.post('nodeops/' + this.$route.params.id + '/setZWaveParamMany', {
            params: this.params
          })         
        }
        
          // Om vi inte editerar betyder det att vi sparar en ny enhet och då behöver
          // vi hämta den nya enheten vi just har lagt till eftersom vi inte får tillbaka
          // den i objektet när vi sparar.
          if (!this.editing) {
            HTTP.get('nodes/' + json.id)
            .then(res => res.data)
            .then(jsonNode => {
              jsonNode.capabilities.forEach(cap => {
                if (!(cap in jsonNode.lastEvents)) {
                  jsonNode.lastEvents[cap] = {}
                }
                
                jsonNode.lastEvents[cap].name = cap
                jsonNode.lastEvents[cap].value = false
                jsonNode.lastEvents[cap].time = new Date()
              })
          
              this.$root.data.nodes.push(jsonNode)
              
              // Skicka användaren till den nya enheten
              this.$router.push({
                name: 'enhet',
                params: {
                  id: json.id
                }
              })
            })
          } else {
            this.$router.push({
              name: 'enhet',
              params: {
                id: this.node.id
              }
            })
          }        
        
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/save_device.vue